import React, { useContext } from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { LocaleContext } from '../../components/LocaleContext';
import { getPersistedMenuDisplayName, getPersistedMenuTabOpenFields } from './menuDisplayLabel';

function LastUsedMenu({ items, props }) {
  const [, dispatch] = useContext(DatabaseContext);
  const { t } = useContext(LocaleContext);

  return (
    <ul className="pt-2 pb-4 space-y-1 text-sm bg-white">
      {(items || []).map((item) => {
        const label = getPersistedMenuDisplayName(item, t);
        const tabFields = getPersistedMenuTabOpenFields(item, t);
        return (
          <li key={`${item.page || 'page'}-${item.name}`}>
            <button
              onDoubleClick={() => dispatch({ type: 'create_new_tab', ...tabFields, page: item.page })}
              onContextMenu={(e) => {
                props.setFavorite(item);
                props.hideAll();
                props.lastUsedFav.current.show(e);
              }}
              className="flex items-start w-full min-w-0 p-2 text-black transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-black dark:hover:bg-gray-100 pl-11"
            >
              <span className="flex-1 min-w-0 text-left break-words [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] overflow-hidden">
                {label}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
export default LastUsedMenu;
